export default __webpack_public_path__ + "img/booking_sent-4b0fb53bc706e93d075adfc4eeab4313.png";